/* eslint-disable */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getOrganisationsToolkit } from "store/orgSlice";
import { selectOrganisation } from "store/orgSlice";
import { selectUser } from "store/authSlice";
import {
  resetUserData,
  getAthletesHistoricalActivities,
} from "store/userSlice";
// import PlayerActivity from './PlayerActivity';
import UserProfileBar from "components/user-profile-components/UserProfileBar";
import "../../styles/user_profile_activity.scss";
import MyTabs from "components/common/mytabs/mytabs";
import useGetPlayer from "components/common/hooks/useGetPlayer";
import useWhyDidYouUpdate from "components/common/hooks/useWhydidyouUpdate";
import { usePrevious } from "components/common/hooks/usePrevious";
import PlayerActivity2Wrapper from "./PlayerActivity2Wrapper/playerActivity2Wrapper";
import AthleteOverview from "components/common/athleteProfile/AthleteOverview";
import { toPng } from "html-to-image";

function UserProfile(props) {
  const { user, actions, match, orgList, history } = props;
  const athleteid = parseInt(match.params.id);
  const player = useGetPlayer(orgList.orgList, match.params.id);
  const prevUrl = usePrevious(athleteid);
  useWhyDidYouUpdate("UserProfile", props);
  
  const userRef = useRef();

  const [athleteLoadDate, setAthleteLoadDate] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [athleteActivitySelected, setAthleteActivitySelected] = useState({});

  function handleSessionAveragedClick(sessionsPayload, sessionActivities) {
    setAthleteLoadDate(sessionsPayload.activePayload[0].payload.TSCreated);
    setAthleteActivitySelected(sessionActivities)
    setTimeout(()=>{
      setAthleteLoadDate("")
    },500)
  }



  function handleLoadClick(loadPayload) {
    setAthleteLoadDate(loadPayload.payload.TSCreated);

    setTimeout(() => {
      setAthleteLoadDate("");
    }, 500);
  }

  function handleLoadClickTable(date) {
    setAthleteLoadDate(date);

    setTimeout(() => {
      setAthleteLoadDate("");
    }, 500);
  }

  useEffect(() => {
    if (athleteid && orgList.orgList.length === 0 && user.id) {
    
      actions.getOrganisationsToolkit(user.id);
      
      // removed as it was stopping athlete from refresing athlete overview page due to lack of organisation object
      // if (user.permissionLevel !== 0) {
      //   actions.getOrganisationsToolkit(user.id);
      // }
    }
  }, [orgList.orgList, athleteid, player, user]);

  useEffect(() => {
    const isAthleteRoute =
      history.location.pathname.includes("/athlete_profile/");
    if ((prevUrl && prevUrl !== athleteid) || isAthleteRoute) {
      actions.resetUserData();
      actions.getAthletesHistoricalActivities(athleteid);
    }
  }, [athleteid, prevUrl]);

  const onButtonClick = useCallback(() => {
    setIsDownloading(true); // Set downloading to true at the beginning

    if (userRef.current === null) {
      setIsDownloading(false); // Set to false if there's an issue with the userRef
      return;
    }

    if (userRef.current) {
    
      // Apply WebKit-based custom scrollbar styles for Chrome/Safari/Edge
      const customScrollbarStyles = `
        ::-webkit-scrollbar {
          width: 0.5em;
          height: 0.5em;
        }

        ::-webkit-scrollbar-thumb {
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        ::-webkit-scrollbar-corner {
          background: rgba(0, 0, 0, 0);
        }
      `;
      const styleElement = document.createElement("style");
      styleElement.innerHTML = customScrollbarStyles;
      userRef.current.appendChild(styleElement);
    }

    toPng(userRef.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `athlete_overview.png`;
        link.href = dataUrl;

        // Simulate file download detection using a setTimeout
        setTimeout(() => {
          link.click(); // Trigger the file download
          console.log("Download triggered successfully.");

          // Set `isDownloading` to false, as we assume the process is complete
          setIsDownloading(false);
        }, 100); // Small delay to simulate the download trigger
      })
      .catch((err) => {
        console.error("Error generating PNG:", err);
        setIsDownloading(false); // Set to false on error
      });
  }, [userRef, player]);

  const tabs = useMemo(
    () => [
      {
        title: "Overview",
        value: "tab1",
        display: (
          <div
            className="user-profile-content"
            ref={userRef}
            id="userRefElement"
          >
            <AthleteOverview
              history={history}
              athleteID={athleteid}
              handleLoadClick={handleLoadClick}
              handleLoadClickTable={handleLoadClickTable}
              downloadButtonClicked={onButtonClick}
              isDownloading={isDownloading}
              handleSessionAveragedClick={handleSessionAveragedClick}
            />
          </div>
        ),
      },
      {
        title: "Sessions",
        value: "tab2",
        display: (
          <PlayerActivity2Wrapper
            match={match}
            history={history}
            playerid={parseInt(athleteid)}
            athleteLoadDate={athleteLoadDate}
            athleteActivitySelected={athleteActivitySelected}
          />
        ),
      },
    ],
    [match, history, athleteLoadDate, isDownloading]
  );

  //hide form function

  if (!player) {
    return <div />;
  }
  return (
    <div className="user-profile-container">
      <UserProfileBar
        orgData={orgList.orgList}
        userData={player}
        history={history}
        param={athleteid}
      />

      <div className="user_profile_metric_container">
        <MyTabs
          key={athleteid}
          headerClass="userProfile"
          tabs={tabs}
          athleteLoadDate={athleteLoadDate}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: selectUser(state),
    // userData: selectUserData(state),
    orgList: selectOrganisation(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOrganisationsToolkit,
      resetUserData,
      getAthletesHistoricalActivities,
    },
    dispatch
  ),
});

export default React.memo(
  connect(mapStateToProps, mapDispatchToProps)(UserProfile)
);
